import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { CodeCoursMarche } from './enum-types/code-cours-marche';
import { UniteCoursMarche } from './unite-cours-marche';
import { ValeurCoursMarche } from './valeur-cours-marche';

@JsonObject
export class Marche {
  constructor (
    id?: string,
    libelle?: string,
    code?: string,
    type?: string,
    uniteBase?: UniteCoursMarche,
    uniteDestination?: UniteCoursMarche,
    valeurs?: ValeurCoursMarche[]
  ) {
    this.id = id as any;
    this.libelle = libelle as any;
    this.code = code as any;
    this.type = type as any;
    this.uniteBase = uniteBase as any;
    this.uniteDestination = uniteDestination as any;
    this.valeurs = valeurs as any;
  }

  @JsonProperty(Number)
  id?: number;

  @JsonProperty(String)
  libelle?: string;

  @JsonProperty(String)
  code?: CodeCoursMarche;

  @JsonProperty(String)
  type?: string;

  @JsonProperty(UniteCoursMarche)
  uniteBase?: UniteCoursMarche;

  @JsonProperty(UniteCoursMarche)
  @Optional
  uniteDestination?: UniteCoursMarche;

  @JsonProperty([ValeurCoursMarche])
  valeurs?: ValeurCoursMarche[];
}
